<template>
  <v-bottom-navigation app fixed grow v-model="activeItem" color="primary">
    <v-btn value="dashboard" :to="{ name: 'dashboard'}">
      <span>Dashboard</span>
      <v-icon dark right>mdi-monitor-dashboard</v-icon>
    </v-btn>

    <v-btn value="projects" :to="{ name: 'projects'}">
      <span>Projects</span>
      <v-icon>mdi-hard-hat</v-icon>
    </v-btn>

    <v-btn value="clients" :to="{ name: 'clients'}">
      <span>Clients</span>
      <v-icon>mdi-account-multiple</v-icon>
    </v-btn>

    <v-btn value="settings" :to="{ name: 'settings'}">
      <span>Settings</span>
      <v-icon>mdi-wrench</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script lang="ts">
export default {
  data() {
    return {
      activeItem: "dashboard"
    };
  }
};
</script>